import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

/** List filters live in the URL so a filtered view can be linked and survives a reload. */
export function useQueryParams() {
  const [params, setParams] = useSearchParams();
  const get = useCallback((key: string) => params.get(key) ?? '', [params]);
  const page = Math.max(1, parseInt(params.get('page') ?? '1', 10) || 1);
  const set = useCallback(
    (changes: Record<string, string | number | undefined | null>, resetPage = true) => {
      const next = new URLSearchParams(params);
      for (const [k, v] of Object.entries(changes)) {
        if (v === undefined || v === null || v === '') next.delete(k);
        else next.set(k, String(v));
      }
      if (resetPage) next.delete('page');
      setParams(next, { replace: true });
    },
    [params, setParams],
  );
  const reset = useCallback(() => setParams(new URLSearchParams(), { replace: true }), [setParams]);
  return { get, page, set, reset, setPage: (p: number) => set({ page: p > 1 ? p : undefined }, false) };
}

export function bool(value: string): boolean | undefined {
  return value === 'true' ? true : value === 'false' ? false : undefined;
}

export function int(value: string): number | undefined {
  const n = parseInt(value, 10);
  return Number.isNaN(n) ? undefined : n;
}
